import { render, staticRenderFns } from "./modalDetallePedidos.vue?vue&type=template&id=5c4a8638&scoped=true&"
import script from "./modalDetallePedidos.vue?vue&type=script&lang=js&"
export * from "./modalDetallePedidos.vue?vue&type=script&lang=js&"
import style0 from "./modalDetallePedidos.vue?vue&type=style&index=0&id=5c4a8638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a8638",
  null
  
)

export default component.exports